import grain from '@/assets/brand/grain.png';
import { cn } from '@/lib/utils';

/**
 * The film grain of the brand book's gradients (Apresentação IDV): a tiled
 * noise texture blended over whatever gradient sits under it.
 */
export function GrainOverlay({ className }: { className?: string }) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'pointer-events-none absolute inset-0 opacity-20 mix-blend-overlay',
        className
      )}
      style={{ backgroundImage: `url(${grain})`, backgroundSize: '160px' }}
    />
  );
}
